(function () {
  'use strict';
  if (window.__mtnAckLoaded) return;
  window.__mtnAckLoaded = true;

  var ATTR = 'Shipping and returns acknowledgement';
  var state = { agreed: false, saved: false };
  var raf = null;

  var st = document.createElement('style');
  st.id = 'mtn-ack-style';
  st.textContent =
    '.mtn-ack{margin:0 0 12px;padding:12px;border:1px solid rgb(var(--color-foreground-rgb, 255 255 255) / 0.25);border-radius:8px;font-size:0.85rem;line-height:1.45}' +
    '.mtn-ack--product{margin:12px 0}' +
    '.mtn-ack__label{display:flex;gap:10px;align-items:flex-start;cursor:pointer}' +
    '.mtn-ack__label input{flex:0 0 auto;width:18px;height:18px;margin:2px 0 0;accent-color:#2f6fd6;cursor:pointer}' +
    '.mtn-ack a{color:inherit;text-decoration:underline}' +
    '.mtn-ack__error{margin:8px 0 0;color:#ff8a80;font-size:0.9rem}' +
    '.mtn-ack__error[hidden]{display:none}' +
    '.mtn-ack-overlay{position:absolute;inset:0;z-index:5;cursor:not-allowed;background:transparent}' +
    '.mtn-ack-overlay[hidden]{display:none}';
  document.head.appendChild(st);

  var DEFAULT_ERROR = 'Please check the box to agree before checking out.';
  var PRODUCT_ERROR = 'Please check the box to agree before adding this to your cart.';

  function visible(el) { return el.offsetParent !== null; }

  function isSupermoto(id) {
    var a = window.MTN_SUPERMOTO_IDS || [];
    for (var i = 0; i < a.length; i++) { if (String(a[i]) === String(id)) return true; }
    return false;
  }

  function wheelRoot() { return document.querySelector('[data-mtn-wheel-options]'); }

  function gatedForm(pf) {
    return !!(pf && pf.getAttribute && !pf.closest('.quick-add') && isSupermoto(pf.getAttribute('data-product-id')) && !wheelRoot());
  }

  function cardUrl(el) {
    var n = el;
    for (var i = 0; n && n !== document.body && i < 10; i++) {
      var a = n.querySelector('a[href*="/products/"]');
      if (a) return a.href;
      n = n.parentElement;
    }
    return null;
  }

  function showErrors(msg) {
    var els = document.querySelectorAll('.mtn-ack__error');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = msg || DEFAULT_ERROR;
      els[i].hidden = false;
    }
    var boxes = document.querySelectorAll('.mtn-ack');
    for (var j = 0; j < boxes.length; j++) {
      if (visible(boxes[j])) {
        boxes[j].scrollIntoView({ block: 'center', behavior: 'smooth' });
        break;
      }
    }
  }

  function hideErrors() {
    var els = document.querySelectorAll('.mtn-ack__error');
    for (var i = 0; i < els.length; i++) els[i].hidden = true;
  }

  function syncBoxes() {
    var c = document.querySelectorAll('.mtn-ack-input');
    for (var i = 0; i < c.length; i++) c[i].checked = state.agreed;
  }

  function wheelMissing() {
    var r = wheelRoot();
    if (!r) return null;
    var g = r.querySelectorAll('[data-mtn-group]');
    for (var i = 0; i < g.length; i++) {
      if (!g[i].querySelector('input:checked')) return g[i];
    }
    return null;
  }

  function showWheelError() {
    var g = wheelMissing();
    if (!g) return;
    var r = wheelRoot();
    var err = r.querySelector('[data-mtn-error]');
    if (err) {
      err.textContent = g.getAttribute('data-msg') || ('Choose your ' + g.getAttribute('data-label') + ' first');
      err.hidden = false;
    }
    g.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function save(on) {
    var attrs = {};
    attrs[ATTR] = on ? ('Agreed ' + new Date().toISOString() + ' (checkbox before checkout)') : '';
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) {
      if (!r.ok) throw new Error('save failed');
      return r.json();
    });
  }

  function refresh() {
    var o = document.querySelectorAll('.mtn-ack-overlay');
    for (var i = 0; i < o.length; i++) {
      var c = o[i].parentNode;
      var mode = c.getAttribute('data-mtn-gate');
      var ok = mode === 'wheel' ? !wheelMissing() : state.agreed;
      o[i].hidden = ok;
      for (var k = 0; k < c.children.length; k++) {
        if (c.children[k] !== o[i]) c.children[k].inert = !ok;
      }
    }
  }

  function link(href, text) {
    var a = document.createElement('a');
    a.href = href;
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = text;
    return a;
  }

  function onChange(e) {
    var on = !!e.target.checked;
    state.agreed = on;
    state.saved = false;
    hideErrors();
    syncBoxes();
    refresh();
    save(on).then(function () { state.saved = true; }).catch(function () { state.saved = false; });
  }

  function makeBox(isProduct) {
    var box = document.createElement('div');
    box.className = isProduct ? 'mtn-ack mtn-ack--product' : 'mtn-ack';
    var label = document.createElement('label');
    label.className = 'mtn-ack__label';
    var cb = document.createElement('input');
    cb.type = 'checkbox';
    cb.className = 'mtn-ack-input';
    cb.checked = state.agreed;
    if (isProduct) {
      cb.name = 'properties[' + ATTR + ']';
      cb.value = 'Agreed';
    }
    cb.addEventListener('change', onChange);
    var span = document.createElement('span');
    span.appendChild(document.createTextNode('I have read and agree to the '));
    span.appendChild(link('/policies/shipping-policy', 'shipping rates'));
    span.appendChild(document.createTextNode(', delivery times, and '));
    span.appendChild(link('/policies/refund-policy', 'return policy'));
    span.appendChild(document.createTextNode(' for each item in my order. I understand delivery dates are estimates.'));
    label.appendChild(cb);
    label.appendChild(span);
    var err = document.createElement('p');
    err.className = 'mtn-ack__error';
    err.setAttribute('role', 'alert');
    err.hidden = true;
    err.textContent = DEFAULT_ERROR;
    box.appendChild(label);
    box.appendChild(err);
    return box;
  }

  function gate(el, mode) {
    el.setAttribute('data-mtn-gate', mode);
    if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
    if (!el.querySelector(':scope > .mtn-ack-overlay')) {
      var o = document.createElement('div');
      o.className = 'mtn-ack-overlay';
      o.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (el.getAttribute('data-mtn-gate') === 'wheel') showWheelError();
        else showErrors();
      });
      el.appendChild(o);
    }
  }

  function scan() {
    var ctas = document.querySelectorAll('.cart__ctas');
    for (var i = 0; i < ctas.length; i++) {
      var c = ctas[i];
      if (!c.querySelector(':scope > .mtn-ack')) c.insertBefore(makeBox(false), c.firstChild);
      var acc = c.querySelector('.additional-checkout-buttons');
      if (acc) gate(acc, 'agree');
    }
    if (wheelRoot()) {
      var blocks = document.querySelectorAll('.accelerated-checkout-block');
      for (var j = 0; j < blocks.length; j++) gate(blocks[j], 'wheel');
    }
    var pfs = document.querySelectorAll('product-form-component[data-product-id]');
    for (var k = 0; k < pfs.length; k++) {
      var pf = pfs[k];
      if (!gatedForm(pf)) continue;
      var row = pf.querySelector('.product-form-buttons');
      if (!row) continue;
      if (!pf.querySelector('.mtn-ack--product')) row.parentNode.insertBefore(makeBox(true), row);
      var ab = pf.querySelector('.accelerated-checkout-block');
      if (ab) gate(ab, 'agree');
    }
    refresh();
  }

  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = null; scan(); });
  }

  function onClickCapture(e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var qb = t.closest('.quick-add__button');
    if (qb) {
      var qa = qb.closest('quick-add-component');
      var pid = qa && qa.getAttribute('data-product-id');
      if (pid && isSupermoto(pid)) {
        var url = cardUrl(qa);
        if (url) {
          e.preventDefault();
          e.stopImmediatePropagation();
          window.location.href = url;
          return;
        }
      }
    }

    var addBtn = t.closest('product-form-component button[type=submit], product-form-component button[name=add]');
    if (addBtn) {
      var pf = addBtn.closest('product-form-component');
      if (gatedForm(pf) && !state.agreed) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showErrors(PRODUCT_ERROR);
        return;
      }
    }

    var btn = t.closest('#checkout, button[name=checkout], a[href^="/checkout"]');
    if (!btn) return;
    if (!state.agreed) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showErrors();
      return;
    }
    if (!state.saved) {
      e.preventDefault();
      e.stopImmediatePropagation();
      save(true).then(function () {
        state.saved = true;
        btn.click();
      }).catch(function () {
        showErrors('Something went wrong saving your agreement. Please try again.');
      });
    }
  }

  function onSubmitCapture(e) {
    var f = e.target;
    if (!f) return;
    var pf = f.closest && f.closest('product-form-component');
    if (pf && gatedForm(pf) && !state.agreed) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showErrors(PRODUCT_ERROR);
      return;
    }
    if (f.id !== 'cart-form') return;
    if (!state.agreed) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showErrors();
    }
  }

  window.addEventListener('click', onClickCapture, true);
  window.addEventListener('pointerdown', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var addBtn = t.closest('product-form-component button[type=submit], product-form-component button[name=add]');
    if (addBtn && gatedForm(addBtn.closest('product-form-component')) && !state.agreed) { e.stopImmediatePropagation(); }
  }, true);
  window.addEventListener('submit', onSubmitCapture, true);

  document.addEventListener('change', function () { setTimeout(refresh, 0); });

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });

  scan();

  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var on = !!(cart && cart.attributes && cart.attributes[ATTR]);
      state.agreed = on;
      state.saved = on;
      syncBoxes();
      refresh();
    })
    .catch(function () {});
})();
